module.exports = __webpack_public_path__ + "img/videoStart.ba6d87e8.png";